import { DEPLOYMENT_KIND_LABELS, DeploymentKind } from '@bhops/shared';

/**
 * 배치 한 줄의 **상태 칸** — "회수됨 / 운영 중 / 기타 · 행사·전시".
 *
 * 오너 결정 2026-09-18 — '운영 중' 은 고객사 매장 배치만이다. 행사·파일럿·인증·테스트·
 * 사내 배치는 로봇 상태가 '기타' 다.
 *
 * ⚠ 2026-09-23 — 종전엔 네 화면(고객사 상세·로봇 출고 이력·배치 이력·매장 상세)이 각자
 *   "미회수면 '운영 중'" 으로 적어, 행사에 나간 로봇도 운영 중으로 보였다. 한 화면만
 *   고치면 나머지가 남는다 — 이 함수 한 벌을 같이 쓴다.
 */
export function DeploymentStatusCell({
  kind,
  returnedAt,
  returnedLabel,
}: {
  kind: DeploymentKind | string | null | undefined;
  returnedAt: string | Date | null | undefined;
  /** 회수된 줄에 무엇을 적을지(기본 '회수됨'). 배치 이력은 회수일을 적는다. */
  returnedLabel?: React.ReactNode;
}): JSX.Element {
  if (returnedAt) {
    return <>{returnedLabel ?? <span style={{ color: 'var(--fg-muted)' }}>회수됨</span>}</>;
  }
  if (kind && kind !== DeploymentKind.CUSTOMER) {
    return (
      <span style={{ color: 'var(--robot-other)' }}>
        기타 · {DEPLOYMENT_KIND_LABELS[kind as DeploymentKind] ?? kind}
      </span>
    );
  }
  return <span style={{ color: 'var(--robot-operating)' }}>운영 중</span>;
}
